import JChartBarProgress from './Control_Charts'
export { JChartBarProgress }
export default JChartBarProgress